import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_TAGS_LIST_REQUEST = 'FETCH_TAGS_LIST_REQUEST';
export const FETCH_TAGS_LIST_SUCCESS = 'FETCH_TAGS_LIST_SUCCESS';
export const FETCH_TAGS_LIST_FAILURE = 'FETCH_TAGS_LIST_FAILURE';
export const LOAD_MORE_TAGS = 'LOAD_MORE_TAGS';
export const FETCH_SUBMISSION_TAGS_LIST_REQUEST = 'FETCH_SUBMISSION_TAGS_LIST_REQUEST';
export const FETCH_SUBMISSION_TAGS_LIST_SUCCESS = 'FETCH_SUBMISSION_TAGS_LIST_SUCCESS';
export const FETCH_SUBMISSION_TAGS_LIST_FAILURE = 'FETCH_SUBMISSION_TAGS_LIST_FAILURE';
export const LOAD_MORE_SUBMISSION_TAGS = 'LOAD_MORE_SUBMISSION_TAGS';

const baseURL = 'agencies/tags';

export const fetchTagsList = (reqParams: ITagListFilters, replaceResults: boolean = false) => {
  const params: ITagListFilters = { ...reqParams };
  const { offset } = params;
  if (params.selectedTagIds) {
    params.selectedTagIds = params.selectedTagIds;
  }

  return {
    [CALL_API]: {
      endpoint: baseURL,
      params,
      method: 'post',
      body: {},
      authenticated: true,
      types: [
        FETCH_TAGS_LIST_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_TAGS : FETCH_TAGS_LIST_SUCCESS,
        FETCH_TAGS_LIST_FAILURE,
      ],
      hideLoadingWidget: true,
    },
  };
};

export const fetchSubmissionTagsList = (
  groupActionRequest: ICRMGroupActionRequest,
  reqParams: ITagListFilters,
  replaceResults: boolean = false
) => {
  const params: ITagListFilters = { ...reqParams };
  const { offset } = params;
  if (params.selectedTagIds) {
    params.selectedTagIds = params.selectedTagIds;
  }

  return {
    [CALL_API]: {
      endpoint: baseURL,
      params,
      method: 'post',
      body: groupActionRequest,
      authenticated: true,
      types: [
        FETCH_SUBMISSION_TAGS_LIST_REQUEST,
        offset && offset > 0 && !replaceResults ? LOAD_MORE_SUBMISSION_TAGS : FETCH_SUBMISSION_TAGS_LIST_SUCCESS,
        FETCH_SUBMISSION_TAGS_LIST_FAILURE,
      ],
      hideLoadingWidget: true,
    },
  };
};
